export default {
	props:{
		formTitle:{type:String, default(){ return this.$t('loginForm.formTitle');} },
		submitUrl:{type:String, default:''},
		email:{type:String, default: ''},
		successMsg:{type:String, default: ''},
		reloadPageOnSuccess:{type:Boolean, default: false},
		googleReCaptchaV3SiteKey:{type:String, default: ''},
	},
	data(){
		return {
			successMsgInner:'',
			formData:{email:'', password:''},
			formErrors:{},
		}
	},
	watch: {
		email:{
			immediate: true,
			handler(val){
				this.$set(this.formData, 'email', val);
			},
		},
		"formData.email":{
			handler(val){
				this.$emit('update:email', val);
			},
		},
		successMsg:{
			immediate: true,
			handler(val){
				this.successMsgInner = val;
				this.formErrors = {};
			},
		}
	},
	computed:{
		actionName(){
			return 'doLogin';
		},
		actionUrl(){
			const url = new URL(this.submitUrl?this.submitUrl:window.location.href);
			url.searchParams.set('action', this.actionName);
			return url.href;
		},
	},
	methods: {
		async onFormSubmit(event){
			this.$refs.loginForm.classList.add('submitting');
			this.formErrors = {};
			this.successMsgInner = '';
			const formData = Object.assign({}, this.formData);

			if(this.googleReCaptchaV3SiteKey){
				formData.grc_token = await this.$refs.googleReCaptchaV3.generateRecaptchaToken(this.actionName);
			}

			doFetch(this.actionUrl, {}, {'formData':formData})
				.then((res) => {
					if (!res || !res.success){
						this.formErrors = res.errors ? res.errors : {'main':'Unknown error!'};
						return;
					}
					if(this.reloadPageOnSuccess){
						window.location.reload();
					} else {
						window.location.href = res.success_url;//redirect
					}
				})
				.catch((error)=>{
					//error
					alert('Unknown error!');
				})
				.finally(()=>{
					this.$refs.loginForm.classList.remove('submitting');
				});
		},
	},
	template: `
<form ref="loginForm" class="login-form client-form" @submit.prevent="onFormSubmit">
	<div v-if="formTitle" class="form-top">{{formTitle}}</div>
	<div v-if="successMsgInner" class="form-msg success">
		<i class="qicon-1">check_outline_mini</i>
		<span v-t="successMsgInner"></span>
	</div>
	<div class="form-content">
		<qit-input-text class="v1" type="email" :label="$t('client.email')" :floating-label="true" v-model="formData.email" :error-msg="formErrors.email"></qit-input-text>
		<qit-input-text class="v1" type="password" :label="$t('client.password')" :floating-label="true" v-model="formData.password" :error-msg="formErrors.password"></qit-input-text>
	</div>
	<div class="form-bottom">
		<button class="btn text-transform-none button fill" name="btnSubmit" :value="actionName" v-t="'loginForm.btnLogin'"></button>
	</div>
	<div v-if="formErrors.main" class="form-msg errors" v-t="formErrors.main"></div>
	
	<slot name="form-bottom"></slot>
	
	<qit-google-recaptcha-v3 ref="googleReCaptchaV3" v-if="googleReCaptchaV3SiteKey" :site-key="googleReCaptchaV3SiteKey"></qit-google-recaptcha-v3>
	
	<div class="form-submitting-overlay"><div class="spin-loader"></div></div>
</form>
`,
}